import React from 'react';

import { Tag } from './styles';

const Skeleton = ({ height, width, ...otherProps }) => (
  <Tag width={width} height={height} {...otherProps} />
);

export default Skeleton;
